import React, { Suspense, type ReactNode } from 'react';

// P1-6 bundle win: lottie-react (→ lottie-web ~250 KB + a module-scope
// setInterval) used to be a STATIC import, so importing ANY symbol from the
// ui-shared barrel dragged the whole engine into every app's entry chunk.
// React.lazy defers loading lottie-web to the first time an animation actually
// renders — non-animation consumers (the vast majority) never pay for it. The
// component API is unchanged; the Suspense boundary that already wrapped Lottie
// now also covers the chunk load.
const Lottie = React.lazy(() => import('lottie-react'));

interface LottieWrapperProps {
  animationData?: Record<string, unknown>;
  src?: string;
  loop?: boolean;
  autoplay?: boolean;
  width?: number | string;
  height?: number | string;
  fallback?: ReactNode;
}

export function LottieAnimation({
  animationData,
  loop = true,
  autoplay = true,
  width = 200,
  height = 200,
  fallback,
}: LottieWrapperProps) {
  if (!animationData) {
    return React.createElement('div', null, fallback ?? null);
  }

  return React.createElement(
    Suspense,
    { fallback: React.createElement('div', { style: { width, height } }, 'Loading...') },
    React.createElement(Lottie, {
      animationData,
      loop,
      autoplay,
      style: { width, height },
    })
  );
}
